define((require) => {
    "use strict";

    const DynamicProductWidgetView    = require("shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetView");
    const DynamicProductWidgetLayout    = require("shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetLayout.js");
    const Matrix                        = require("shared/vendor/Matrix");
    const _                             = require("underscore");


    /**
     * Mixin the editor related logic for the <tt>TextWidgetView</tt>.
     *
     * @see  TextWidgetView
     */
    return DynamicProductWidgetView.mixin("DynamicProductWidgetViewEditorMixin", {

        _renderLayout() {
            this._layout = new DynamicProductWidgetLayout({el: this.$el});
            this._layout.render();
            this._showGroupedWidgetCollectionView();
        },

        showView() {
            if (this.groupCollection) {
                this._layout = new DynamicProductWidgetLayout({el: this.$el});
                this._layout.render();

                this._setGroupedWidgetCollectionView();

                // Add each widget in the group to the widget transformer
                // so they can be selected individually.
                this.listenTo(this.groupCollectionView, "collection:rendered", () => {
                    _.defer(() => {
                        this.groupCollectionView.children.each((itemView) => {
                            const parentTransform = Matrix.createFromString(this.$el.css("transform"));
                            if (this.options && this.options.addChildWidgetToTransformer) {
                                this.options.addChildWidgetToTransformer(itemView, parentTransform);
                            }
                        });
                    });
                });

                this._showGroupedWidgetCollectionView();

                // Update the controls when the height/width are manually
                // changed in the sidebar controls. Debounce the update as there
                // will otherwise be multiple events fired when a number is
                // typed in manually.
                this.groupCollectionView.children.forEach((widget) => {
                    this.listenTo(widget, "updated:rendering", _.debounce(() => {
                        if (this.options && this.options.hasOwnProperty("updateControls")) {
                            this.options.updateControls();
                        }
                    }, 100));
                });

                // When the widget is moved, remove and re-add the children to the
                // transformer so their position is updated.
                this.listenTo(this.model, "change:left change:top", () => {
                    // When a subwidget is dragged and forces the group's bounding box to adjust,
                    // the DOM element's transform CSS property needs to be recalculated based on the
                    // widget model's properties.
                    const unscaledExperienceSize = this._experienceSize();
                    const rect = {
                        x: (this.model.get("scaledLeft") / 100) * unscaledExperienceSize.width,
                        y: (this.model.get("scaledTop") / 100) * unscaledExperienceSize.height
                    };
                    const newMatrix = Matrix.createFromString(this.$el.css("transform"));
                    newMatrix.x = rect.x;
                    newMatrix.y = rect.y;

                    const selectedUuids = this.viewModel.selection.get("widgets").map((e) => e.model.get("uuid"));
                    this.groupCollectionView.children.each((itemView) => {
                        // Determine whether this widget is currently selected by
                        // checking whether its UUID is included in selectedUuids
                        const widgetUuid = itemView.model.get("uuid");
                        const widgetSelected = selectedUuids.indexOf(widgetUuid) > -1;

                        const parentTransform = newMatrix;
                        if (this.options) {
                            // If this widget was selected, unselect the removed instance
                            // before removing it and reselect it after it's been re-added.
                            if (widgetSelected) {
                                this.viewModel.selection.remove(itemView);
                            }
                            this.options.removeChildWidgetFromTransformer(itemView);
                            this.options.addChildWidgetToTransformer(itemView, parentTransform);
                            if (widgetSelected) {
                                this.viewModel.selection.append(itemView);
                            }
                        }
                    });
                });
            }

            this.__super();

            if (!this.options.edited) {
                _.defer(this._makeElementUnreachable.bind(this));
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetViewEditorMixin.js